import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import CaseBox from "../components/caseBox"
import styled from "@emotion/styled"
import Splash from "../components/splash"
import HalfBlocks from "../components/halfBlocks"
import { callToActionStyle } from "../styles"
import { CAPABILITIES } from "../config"

const Capabilities = styled.div`
  h2 {
    font: 400 ${props => props.theme.fontSize.header}
      ${props => props.theme.fonts.serif};
  }
  h3 {
    font: 400 ${props => props.theme.fontSize.subheader}
      ${props => props.theme.fonts.serif};
  }
  a {
    text-decoration: none;
    color: ${props => props.theme.colors.primary};
    font-size: ${props => props.theme.fontSize.paragraph};
    &:hover {
      text-decoration: underline;
    }
  }
`

const CaseStudiesTemplate = ({ images, options }) => (
  <Layout>
    <SEO title={`Case Study | ${options.title}`} />
    <Splash subtitle="Case Study" title={`${options.title}`}>
      <Img style={{ minHeight: "150px" }} fluid={images[images.length - 1]} />
    </Splash>
    <CaseBox>
      <section>
        <div className="summary">
          <p>{options.summary.text}</p>
        </div>
      </section>
      <HalfBlocks blocks={renderBlocks(options.body, images)} />
    </CaseBox>
    <Capabilities>
      <h3>Relevant Capabilities</h3>
      {options.summary.capabilities.map(c => (
        <p>
          <Link to={CAPABILITIES[c].href}>{CAPABILITIES[c].title}</Link>
        </p>
      ))}
    </Capabilities>
    <br />
    <Link to="/case-studies" css={theme => callToActionStyle(theme)}>
      View All Case Studies
    </Link>
  </Layout>
)

const renderBlocks = (body, images) => {
  return body.map((b, i) => ({
    ...b,
    img: images && images[i] ? images[i] : undefined,
  }))
}

export default CaseStudiesTemplate
